import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setFormValues } from "../../../app/slices/applicationsSlice";
import AppCheckListItem from "../../../components/AppCheckListItem/AppCheckListItem";
import LoadingContainer from "../../../components/loadingContainer/loadingContainer";
import AttachmentsContainer from "../../../components/AttachmentsContainer/AttachmentsContainer";
import attachmentTypes from "../../../assets/static/attachmentTypes.json";

const AttachmentsFragment = ({ errors: formErrors }) => {
  const { formValues } = useSelector(({ applications }) => applications);
  const { list, status: statusGet } = useSelector(
    ({ attachments }) => attachments.get
  );

  const dispatch = useDispatch();

  //use effects
  useEffect(() => {
    if (list) {
      dispatch(setFormValues({ ...formValues, attachments: list }));
    }
  }, [list]);

  //builders
  const BuildCheckList = () => {
    return (
      <>
        <div className="mb-5">
          Upload the attachments listed below (* Mandatory):
        </div>
        <div style={{ padding: "5px 20px" }}>
          {statusGet === "idle" && (
            <>
              <AppCheckListItem
                title={"Application letter (Maximum 1 page)*"}
                isComplete={
                  list?.find((x) => x?.TYPE === "Application letter") !==
                  undefined
                }
              />
              <AppCheckListItem
                title={"Detailed Business Plan (Maximum 50 pages)*"}
                isComplete={
                  list?.find((x) => x?.TYPE === "Business plan") !== undefined
                }
              />
              <AppCheckListItem
                title={"Detailed Testing Plan (Maximum 25 pages)*"}
                isComplete={
                  list?.find((x) => x?.TYPE === "Testing plan") !== undefined
                }
              />
              <AppCheckListItem
                title={"Detailed Exit Strategy (Maximum 15 pages)*"}
                isComplete={
                  list?.find((x) => x?.TYPE === "Exit strategy") !== undefined
                }
              />
              <AppCheckListItem
                title={
                  "Certified copy of Certificate of Incorporation (Maximum 2 page)*"
                }
                isComplete={
                  list?.find(
                    (x) => x?.TYPE === "Certificate of incorporation"
                  ) !== undefined
                }
              />
              <AppCheckListItem
                title={"Financial Solution Risk Profile (Maximum 15 pages)*"}
                isComplete={
                  list?.find((x) => x?.TYPE === "Risk profile") !== undefined
                }
              />
              <AppCheckListItem
                title={
                  "Duly executed Agreement between the Applicant and the owner of the testing environment (Maximum 2 pages)*"
                }
                isComplete={
                  list?.find(
                    (x) => x?.TYPE === "Agreement between applicant and owner"
                  ) !== undefined
                }
              />
              <AppCheckListItem
                title={
                  "Certified copies of the memorandum and articles of association (Maximum 50 pages)*"
                }
                isComplete={
                  list?.find(
                    (x) => x?.TYPE === "Memorandum and articles of association"
                  ) !== undefined
                }
              />
              <AppCheckListItem
                title={
                  "An original letter from the Registrar of Companies (Maximum 25 pages)*"
                }
                isComplete={
                  list?.find(
                    (x) =>
                      x?.TYPE ===
                      "Original letter from the registrar of companies"
                  ) !== undefined
                }
              />
              <AppCheckListItem
                title={"Shareholder's declaration (Maximum 1 page)*"}
                isComplete={
                  list?.find((x) => x?.TYPE === "Shareholders' declaration") !==
                  undefined
                }
              />
            </>
          )}
          {statusGet === "loading" && (
            <LoadingContainer
              hasBackground={false}
              hasFixedHeight={false}
              message="loading..."
            />
          )}
        </div>
      </>
    );
  };

  return (
    <div className="app-padding">
      <h2 className="mb-10">Attachments</h2>
      {BuildCheckList()}
      <div className="mt-20">
        <AttachmentsContainer
          recordId={formValues?.applicationId}
          sourceTable="applications"
          attachmentTypes={attachmentTypes}
        />
      </div>
      {formErrors?.attachments && (
        <div className="flex-row mb-10 mt-20 align-items-center">
          <div className="list-bullet mr-10"></div>
          <div className="text-red">Provide all mandatory attachments (*)</div>
        </div>
      )}
    </div>
  );
};

export default AttachmentsFragment;
